import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Button from "../../../Components/UI/buttonGlobal";
import { getCountries } from "../../../MyApi/admin/countries/countries";
import { useMutation, useQuery } from "react-query";
import { postLoyaltySetting, showLoyaltySetting, updateLoyaltySetting } from "../../../MyApi/loyalty";
import { toast } from "react-toastify";
import i18next from "i18next";
import { formatPrice } from "../../../utils/formatPrice";
import SkeletonWrapper from "../../../Components/UI/skeletonWrapper";

const LoyaltyModal = ({ isOpen, toggle, refetch, modalMode, modalId }) => {
  const [formData, setFormData] = useState({
    country_id: "",
    currency_factor:"",
    earn_rate: 0,
    min_order_for_earn: 0,
    referral_points: 0,
    rating_points: 0,
    point_value_in_currency: 100,
    monthly_reset_day: 1,
    auto_convert_to_discount: false,
    min_spending_for_annual_race: 0,
    free_delivery_points_cost: 50,
    free_delivery_min_order: 300000,
    max_points_per_order: 500,
    rate_limit_per_hour: 5,
    is_enabled: true,
    badge_multipliers: {
      hot: 1.2,
      vip: 1.3,
      promo: 2.0,
      clean: 1.0
    }
  });

  const [errors, setErrors] = useState({});

  const { data: countriesData, isLoading: countriesLoading } = useQuery(
    "getCountries",
    () => getCountries()
  );

  const countries = countriesData?.data?.countries || [];


  const { data: showData, isLoading: showLoading } = useQuery(
    ["showLoyaltySetting", modalId],
    () => showLoyaltySetting(modalId),
    {
      enabled: !!modalId && (modalMode === "edit"|| modalMode  ==="show")
    }
  );

  const loyaltySetting = showData?.data?.LoyaltySetting || {};

  const mutation = useMutation({
    mutationKey: ["postLoyaltySetting"],
    mutationFn: (postData) => postLoyaltySetting(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      toggle();
      refetch();
      resetForm();
    },
    onError: (error) => {
      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors);
      } else {
        toast.error(`${error.response?.data?.message || "حدث خطأ ما"}`);
      }
    }
  });

  const updateMutation = useMutation({
    mutationKey: ["updateLoyaltySetting"],
    mutationFn: (postData) => updateLoyaltySetting(postData, modalId),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      toggle();
      refetch();
    },
    onError: (error) => {
      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors);
      } else {
        toast.error(`${error.response?.data?.message || "حدث خطأ ما"}`);
      }
    }
  });

  const resetForm = () => {
    setFormData({
      country_id: "",
      currency_factor:"",
      earn_rate: 0,
      min_order_for_earn: 0,
      referral_points: 0,
      rating_points: 0,
      point_value_in_currency: 100,
      monthly_reset_day: 1,
      auto_convert_to_discount: false,
      min_spending_for_annual_race: 0,
      free_delivery_points_cost: 0,
      free_delivery_min_order: 0,
      max_points_per_order: 0,
      rate_limit_per_hour: 0,
      is_enabled: true,
      badge_multipliers: {
        hot: 0,
        vip:0,
        promo: 0,
        clean:0
      }
    });
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const isCheckbox = type === "checkbox";
    
    if (name.startsWith("badge_multipliers.")) {
      const multiplierKey = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        badge_multipliers: {
          ...prev.badge_multipliers,
          [multiplierKey]: parseFloat(value) || 0
        }
      }));
    } else if (isCheckbox) {
      setFormData((prev) => ({
        ...prev,
        [name]: checked
      }));
    } else {
      // Convert numeric fields to numbers
      const numericFields = [
        "earn_rate", "min_order_for_earn", "referral_points", "rating_points",
        "point_value_in_currency", "monthly_reset_day", "min_spending_for_annual_race",
        "free_delivery_points_cost", "free_delivery_min_order", "max_points_per_order", "rate_limit_per_hour"
      ];
      if (numericFields.includes(name)) {
        setFormData((prev) => ({
          ...prev,
          [name]: parseFloat(value) || 0
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: value
        }));
      }
    }

    if(name ==="country_id"){
      setFormData((prev)=>({
        ...prev, 
        currency_factor:e.target.options[e.target.selectedIndex].id
      }))
    }

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const handleSubmit = () => {
    // Validate required fields
    const newErrors = {};
    if (!formData.country_id) {
      newErrors.country_id = ["يجب اختيار الدولة"];
    }
    if (!formData.earn_rate || formData.earn_rate === 0) {
      newErrors.earn_rate = ["معدل الكسب يجب أن يكون أكبر من 0"];
    }
    if (!formData.min_order_for_earn || formData.min_order_for_earn <= 0) {
      newErrors.min_order_for_earn = ["الحد الأدنى للطلب يجب أن يكون أكبر من 0"];
    }
    if (!formData.referral_points || formData.referral_points < 0) {
      newErrors.referral_points = ["نقاط الإحالة يجب أن تكون 0 أو أكبر"];
    }
    if (!formData.rating_points || formData.rating_points < 0) {
      newErrors.rating_points = ["نقاط التقييم يجب أن تكون 0 أو أكبر"];
    }
    if (!formData.point_value_in_currency || formData.point_value_in_currency <= 0) {
      newErrors.point_value_in_currency = ["قيمة النقطة يجب أن تكون أكبر من 0"];
    }
    if (!formData.monthly_reset_day || formData.monthly_reset_day < 1 || formData.monthly_reset_day > 31) {
      newErrors.monthly_reset_day = ["يوم الإعادة الشهرية يجب أن يكون بين 1 و 31"];
    }
    if (!formData.free_delivery_points_cost || formData.free_delivery_points_cost < 0) {
      newErrors.free_delivery_points_cost = ["نقاط التوصيل المجاني يجب أن تكون 0 أو أكبر"];
    }
    if (!formData.free_delivery_min_order || formData.free_delivery_min_order < 0) {
      newErrors.free_delivery_min_order = ["الحد الأدنى للطلب للتوصيل المجاني يجب أن يكون 0 أو أكبر"];
    }
    if (!formData.max_points_per_order || formData.max_points_per_order <= 0) {
      newErrors.max_points_per_order = ["أقصى نقاط لكل طلب يجب أن يكون أكبر من 0"];
    }
    if (!formData.rate_limit_per_hour || formData.rate_limit_per_hour <= 0) {
      newErrors.rate_limit_per_hour = ["الحد الأقصى لكل ساعة يجب أن يكون أكبر من 0"];
    }
    // Validate badge multipliers
    const badgeKeys = ["hot", "vip", "promo", "clean"];
    badgeKeys.forEach(key => {
      const value = formData.badge_multipliers[key];
      if (!value || value < 0) {
        newErrors[`badge_multipliers.${key}`] = [`معامل ${key} يجب أن يكون 0 أو أكبر`];
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (modalMode === "edit") {
      const formDataToSend = new FormData();
      formDataToSend.append("country_id", formData.country_id);
      formDataToSend.append("currency_factor", formData.currency_factor);
      formDataToSend.append("earn_rate", formData.earn_rate);
      formDataToSend.append("min_order_for_earn", formData.min_order_for_earn);
      formDataToSend.append("referral_points", formData.referral_points);
      formDataToSend.append("rating_points", formData.rating_points);
      formDataToSend.append("point_value_in_currency", formData.point_value_in_currency);
      formDataToSend.append("monthly_reset_day", formData.monthly_reset_day);
      formDataToSend.append("auto_convert_to_discount", formData.auto_convert_to_discount ? 1 : 0);
      formDataToSend.append("min_spending_for_annual_race", formData.min_spending_for_annual_race);
      formDataToSend.append("free_delivery_points_cost", formData.free_delivery_points_cost);
      formDataToSend.append("free_delivery_min_order", formData.free_delivery_min_order);
      formDataToSend.append("max_points_per_order", formData.max_points_per_order);
      formDataToSend.append("rate_limit_per_hour", formData.rate_limit_per_hour);
      formDataToSend.append("is_enabled", formData.is_enabled ? 1 : 0);
      formDataToSend.append("badge_multipliers[hot]", formData.badge_multipliers.hot);
      formDataToSend.append("badge_multipliers[vip]", formData.badge_multipliers.vip);
      formDataToSend.append("badge_multipliers[promo]", formData.badge_multipliers.promo);
      formDataToSend.append("badge_multipliers[clean]", formData.badge_multipliers.clean);
      formDataToSend.append("_method", "PUT");

      updateMutation.mutate(formDataToSend);
    } else {
      const dataToSend = {
        ...formData,
        auto_convert_to_discount: formData.auto_convert_to_discount ? 1 : 0,
        is_enabled: formData.is_enabled ? 1 : 0,
      };
      mutation.mutate(dataToSend);
    }
  };

  useEffect(() => {
    if (modalMode === "edit" ||modalMode ==="show" && loyaltySetting && Object.keys(loyaltySetting).length > 0) {
      setFormData({
        country_id: loyaltySetting?.country?.id || "",
        currency_factor: loyaltySetting?.country?.currency_factor || "",
        earn_rate: loyaltySetting.earn_rate || 0,
        min_order_for_earn: formatPrice(loyaltySetting?.country?.currency_factor ,loyaltySetting?.min_order_for_earn ) || 0,
        referral_points: loyaltySetting.referral_points || 0,
        rating_points: loyaltySetting.rating_points || 0,
        point_value_in_currency: loyaltySetting.point_value_in_currency || 100,
        monthly_reset_day: loyaltySetting.monthly_reset_day || 1,
        auto_convert_to_discount: loyaltySetting.auto_convert_to_discount ? true : false,
        min_spending_for_annual_race: loyaltySetting.min_spending_for_annual_race || 0,
        free_delivery_points_cost: loyaltySetting.free_delivery_points_cost || 50,
        free_delivery_min_order: loyaltySetting.free_delivery_min_order || 300000,
        max_points_per_order: loyaltySetting.max_points_per_order || 500,
        rate_limit_per_hour: loyaltySetting.rate_limit_per_hour || 5,
        is_enabled: loyaltySetting.is_enabled !== false ? true : false,
        badge_multipliers: loyaltySetting.badge_multipliers || {
          hot: 1.2,
          vip: 1.3,
          promo: 2.0,
          clean: 1.0
        }
      });
    }
  }, [loyaltySetting, modalMode]);

  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const isDisabled = modalMode === "show";
  const isLoading =  mutation.isLoading || updateMutation.isLoading;

  const getModalTitle = () => {
    switch (modalMode) {
      case "edit":
        return "تعديل إعداد الولاء";
      case "show":
        return "عرض إعداد الولاء";
      default:
        return "إضافة إعداد ولاء جديد";
    }
  };

  const getSubmitButtonLabel = () => {
    switch (modalMode) {
      case "edit":
        return "تعديل إعداد الولاء";
      default:
        return "إضافة إعداد الولاء";
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>{getModalTitle()}</ModalHeader>
      <ModalBody className="add">
        <div className="row">
          <div className="col-12 mb-3">
            <label htmlFor="country_id" className="form-label">
              الدولة 
            </label>
            <SkeletonWrapper isLoading={showLoading}>

            <select
              name="country_id"
              id="country_id"
              value={formData.country_id}
              onChange={handleChange}
              className={`form-select ${errors.country_id ? 'is-invalid' : ''}`}
              disabled={countriesLoading || isDisabled}
              >
              <option value="">اختر الدولة</option>
              {countries.map((country) => (
                <option key={country.id} id={country.currency_factor} value={country.id}>
                  {country.name} ({country.code})
                </option>
              ))}
            </select>
              </SkeletonWrapper>
            {errors.country_id && (
              <div className="invalid-feedback d-block">
                {errors.country_id[0]}
              </div>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label htmlFor="earn_rate" className="form-label">
              معدل الكسب (%) 
            </label>
              <SkeletonWrapper isLoading={showLoading}>

            <input
              type="number"
              name="earn_rate"
              id="earn_rate"
              value={formData.earn_rate}
              onChange={handleChange}
              className={`form-control ${errors.earn_rate ? 'is-invalid' : ''}`}
              placeholder="0.1"
              step="0.01"
              min="0"
              disabled={isDisabled}
              />
              </SkeletonWrapper>
            {errors.earn_rate && (
              <div className="invalid-feedback d-block">
                {errors.earn_rate[0]}
              </div>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label htmlFor="min_order_for_earn" className="form-label">
              الحد الأدنى للطلب 
            </label>
                 <SkeletonWrapper isLoading={showLoading}>

            <input
              type="number"
              name="min_order_for_earn"
              id="min_order_for_earn"
              value={formData.min_order_for_earn}
              onChange={handleChange}
              className={`form-control ${errors.min_order_for_earn ? 'is-invalid' : ''}`}
              placeholder="10"
              min="0"
              disabled={isDisabled}
              />
              </SkeletonWrapper>
            {errors.min_order_for_earn && (
              <div className="invalid-feedback d-block">
                {errors.min_order_for_earn[0]}
              </div>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label htmlFor="referral_points" className="form-label">
              نقاط الإحالة 
            </label>
             <SkeletonWrapper isLoading={showLoading}>

            <input
              type="number"
              name="referral_points"
              id="referral_points"
              value={formData.referral_points}
              onChange={handleChange}
              className={`form-control ${errors.referral_points ? 'is-invalid' : ''}`}
              placeholder="20"
              min="0"
              disabled={isDisabled}
              />
              </SkeletonWrapper>
            {errors.referral_points && (
              <div className="invalid-feedback d-block">
                {errors.referral_points[0]}
              </div>
            )}
          </div>

           <div className="col-md-6 mb-3">
             <label htmlFor="rating_points" className="form-label">
               نقاط التقييم 
             </label>
              <SkeletonWrapper isLoading={showLoading}>

             <input
               type="number"
               name="rating_points"
               id="rating_points"
               value={formData.rating_points}
               onChange={handleChange}
               className={`form-control ${errors.rating_points ? 'is-invalid' : ''}`}
               placeholder="5"
               min="0"
               disabled={isDisabled}
               />
               </SkeletonWrapper>
             {errors.rating_points && (
               <div className="invalid-feedback d-block">
                 {errors.rating_points[0]}
               </div>
             )}
           </div>

           {/* New Fields */}
           
           {/* Point Value in Currency */}
           <div className="col-md-6 mb-3">
             <label htmlFor="point_value_in_currency" className="form-label">
               قيمة النقطة بالعملة 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="point_value_in_currency"
                 id="point_value_in_currency"
                 value={formData.point_value_in_currency}
                 onChange={handleChange}
                 className={`form-control ${errors.point_value_in_currency ? 'is-invalid' : ''}`}
                 placeholder="100"
                 step="0.01"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors.point_value_in_currency && (
               <div className="invalid-feedback d-block">
                 {errors.point_value_in_currency[0]}
               </div>
             )}
           </div>

           {/* Monthly Reset Day */}
           <div className="col-md-6 mb-3">
             <label htmlFor="monthly_reset_day" className="form-label">
               يوم الإعادة الشهرية 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="monthly_reset_day"
                 id="monthly_reset_day"
                 value={formData.monthly_reset_day}
                 onChange={handleChange}
                 className={`form-control ${errors.monthly_reset_day ? 'is-invalid' : ''}`}
                 placeholder="1"
                 min="1"
                 max="31"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors.monthly_reset_day && (
               <div className="invalid-feedback d-block">
                 {errors.monthly_reset_day[0]}
               </div>
             )}
           </div>

           {/* Auto Convert to Discount */}
           <div className="col-md-6 mb-3">
             <label htmlFor="auto_convert_to_discount" className="form-label">
               تحويل تلقائي للخصم 
             </label>
             <div className="form-check">
               <input
                 type="checkbox"
                 name="auto_convert_to_discount"
                 id="auto_convert_to_discount"
                 checked={formData.auto_convert_to_discount}
                 onChange={handleChange}
                 disabled={isDisabled}
                 className="form-check-input"
               />
               <label className="form-check-label" htmlFor="auto_convert_to_discount">
                 تفعيل التحويل التلقائي للنقاط إلى خصم
               </label>
             </div>
           </div>

           {/* Min Spending for Annual Race */}
           <div className="col-md-6 mb-3">
             <label htmlFor="min_spending_for_annual_race" className="form-label">
               الحد الأدنى للإنفاق للسباق السنوي 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="min_spending_for_annual_race"
                 id="min_spending_for_annual_race"
                 value={formData.min_spending_for_annual_race}
                 onChange={handleChange}
                 className={`form-control ${errors.min_spending_for_annual_race ? 'is-invalid' : ''}`}
                 placeholder="0"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors.min_spending_for_annual_race && (
               <div className="invalid-feedback d-block">
                 {errors.min_spending_for_annual_race[0]}
               </div>
             )}
           </div>

           {/* Free Delivery Points Cost */}
           <div className="col-md-6 mb-3">
             <label htmlFor="free_delivery_points_cost" className="form-label">
               تكلفة نقاط التوصيل المجاني 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="free_delivery_points_cost"
                 id="free_delivery_points_cost"
                 value={formData.free_delivery_points_cost}
                 onChange={handleChange}
                 className={`form-control ${errors.free_delivery_points_cost ? 'is-invalid' : ''}`}
                 placeholder="50"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors.free_delivery_points_cost && (
               <div className="invalid-feedback d-block">
                 {errors.free_delivery_points_cost[0]}
               </div>
             )}
           </div>

           {/* Free Delivery Min Order */}
           <div className="col-md-6 mb-3">
             <label htmlFor="free_delivery_min_order" className="form-label">
               الحد الأدنى للطلب للتوصيل المجاني 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="free_delivery_min_order"
                 id="free_delivery_min_order"
                 value={formData.free_delivery_min_order}
                 onChange={handleChange}
                 className={`form-control ${errors.free_delivery_min_order ? 'is-invalid' : ''}`}
                 placeholder="300000"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors.free_delivery_min_order && (
               <div className="invalid-feedback d-block">
                 {errors.free_delivery_min_order[0]}
               </div>
             )}
           </div>

           {/* Max Points Per Order */}
           <div className="col-md-6 mb-3">
             <label htmlFor="max_points_per_order" className="form-label">
               أقصى نقاط لكل طلب 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="max_points_per_order"
                 id="max_points_per_order"
                 value={formData.max_points_per_order}
                 onChange={handleChange}
                 className={`form-control ${errors.max_points_per_order ? 'is-invalid' : ''}`}
                 placeholder="500"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors.max_points_per_order && (
               <div className="invalid-feedback d-block">
                 {errors.max_points_per_order[0]}
               </div>
             )}
           </div>

           {/* Rate Limit Per Hour */}
           <div className="col-md-6 mb-3">
             <label htmlFor="rate_limit_per_hour" className="form-label">
               الحد الأقصى لكل ساعة 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="rate_limit_per_hour"
                 id="rate_limit_per_hour"
                 value={formData.rate_limit_per_hour}
                 onChange={handleChange}
                 className={`form-control ${errors.rate_limit_per_hour ? 'is-invalid' : ''}`}
                 placeholder="5"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors.rate_limit_per_hour && (
               <div className="invalid-feedback d-block">
                 {errors.rate_limit_per_hour[0]}
               </div>
             )}
           </div>

           {/* Is Enabled */}
           <div className="col-md-6 mb-3">
             <label htmlFor="is_enabled" className="form-label">
               الحالة 
             </label>
             <div className="form-check">
               <input
                 type="checkbox"
                 name="is_enabled"
                 id="is_enabled"
                 checked={formData.is_enabled}
                 onChange={handleChange}
                 disabled={isDisabled}
                 className="form-check-input"
               />
               <label className="form-check-label" htmlFor="is_enabled">
                 تفعيل نظام الولاء
               </label>
             </div>
           </div>

           {/* Badge Multipliers Section */}
           <div className="col-12 mb-3">
             <h6 className="form-section-title">معاملات الشارات (Badge Multipliers)</h6>
           </div>

           <div className="col-md-6 mb-3">
             <label htmlFor="badge_multipliers.hot" className="form-label">
               معامل Hot 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="badge_multipliers.hot"
                 id="badge_multipliers.hot"
                 value={formData.badge_multipliers.hot}
                 onChange={handleChange}
                 className={`form-control ${errors['badge_multipliers.hot'] ? 'is-invalid' : ''}`}
                 placeholder="1.2"
                 step="0.1"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors['badge_multipliers.hot'] && (
               <div className="invalid-feedback d-block">
                 {errors['badge_multipliers.hot'][0]}
               </div>
             )}
           </div>

           <div className="col-md-6 mb-3">
             <label htmlFor="badge_multipliers.vip" className="form-label">
               معامل VIP 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="badge_multipliers.vip"
                 id="badge_multipliers.vip"
                 value={formData.badge_multipliers.vip}
                 onChange={handleChange}
                 className={`form-control ${errors['badge_multipliers.vip'] ? 'is-invalid' : ''}`}
                 placeholder="1.3"
                 step="0.1"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors['badge_multipliers.vip'] && (
               <div className="invalid-feedback d-block">
                 {errors['badge_multipliers.vip'][0]}
               </div>
             )}
           </div>

           <div className="col-md-6 mb-3">
             <label htmlFor="badge_multipliers.promo" className="form-label">
               معامل Promo 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="badge_multipliers.promo"
                 id="badge_multipliers.promo"
                 value={formData.badge_multipliers.promo}
                 onChange={handleChange}
                 className={`form-control ${errors['badge_multipliers.promo'] ? 'is-invalid' : ''}`}
                 placeholder="2.0"
                 step="0.1"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors['badge_multipliers.promo'] && (
               <div className="invalid-feedback d-block">
                 {errors['badge_multipliers.promo'][0]}
               </div>
             )}
           </div>

           <div className="col-md-6 mb-3">
             <label htmlFor="badge_multipliers.clean" className="form-label">
               معامل Clean 
             </label>
             <SkeletonWrapper isLoading={showLoading}>
               <input
                 type="number"
                 name="badge_multipliers.clean"
                 id="badge_multipliers.clean"
                 value={formData.badge_multipliers.clean}
                 onChange={handleChange}
                 className={`form-control ${errors['badge_multipliers.clean'] ? 'is-invalid' : ''}`}
                 placeholder="1.0"
                 step="0.1"
                 min="0"
                 disabled={isDisabled}
               />
             </SkeletonWrapper>
             {errors['badge_multipliers.clean'] && (
               <div className="invalid-feedback d-block">
                 {errors['badge_multipliers.clean'][0]}
               </div>
             )}
           </div>
         </div>

        {modalMode !== "show" && (
          <div className="d-flex justify-content-start gap-2 mt-3">
            <Button
              className="btn-primary"
              label={getSubmitButtonLabel()}
              onClick={handleSubmit}
              isLoading={isLoading}
              disabled={isLoading}
            />

            <Button
              className="btn-white"
              label={"إلغاء"}
              onClick={toggle}
              disabled={isLoading}
            />
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default LoyaltyModal;